import { render } from "./app.vue?vue&type=template&id=c9f72fee"
import script from "./app.vue?vue&type=script&lang=js"
export * from "./app.vue?vue&type=script&lang=js"

import "./app.vue?vue&type=style&index=0&id=c9f72fee&lang=scss"

import exportComponent from "/Users/xinliu/lubber/js_projects/qrcode-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__